export default {
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  pageTitle: {
    margin: "30px 0px"
  },
  header: {
    color: "#3276b1"
  },
  headerContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 40
  }
};
